import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-frame-options-product-configuration',
  templateUrl: './frame-options-product-configuration.component.html',
  styleUrls: ['./frame-options-product-configuration.component.scss']
})
export class FrameOptionsProductConfigurationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
